import { FieldDataType } from 'src/app/models/module-structure';

export interface ListPayload {
  PageIndex: number;
  PageSize: number;
  OrderByField: string;
  IsAsc: boolean;
  Conditions?: ConditionObject[];
}
export interface ConditionObject {
  Value: any;
  Key: string;
  Type: FieldDataType;
  Operator?: ConditionOperator;
}

export enum ConditionOperator {
  equals,
  greater,
  less,
  greaterOrEquals,
  lessOrEquals,
  notEquals,
}
